export default __webpack_public_path__ + "static/65285913-0-cgmc-play-600-09a598a70563247eac374b37963d0232.jpg";